import { useMutation, useQueryClient } from '@tanstack/react-query';

import { Query, Model } from './api';

export const useLogin = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (loginData) => {
      console.log('🔐 Login attempt:', loginData);
      const loginInstance = new Model('login', loginData);
      console.log('📦 Login model:', loginInstance.toAPI());
      return await new Query('login').setData(loginInstance.toAPI()).run();
    },
    onError: (error) => {
      console.error('🚫 Login error:', error);
    },
    onSuccess: (data) => {
      console.log('✅ Login success:', data);
      queryClient.invalidateQueries({ queryKey: ['users', 'me'] });
      // Ensure any dependent auth/account data is refreshed
      queryClient.invalidateQueries({ queryKey: ['accounts'] });
      queryClient.invalidateQueries({ queryKey: ['currentAccount'] });
      // Trigger immediate refetch of user data for responsive UI
      queryClient.refetchQueries({ queryKey: ['users', 'me'] });
    },
  });
};
